import React from 'react'
import Slider from 'react-slick';
import "../../../node_modules/slick-carousel/slick/slick.css";
import "../../../node_modules/slick-carousel/slick/slick-theme.css";
import HomePageData from './home-data';

function SolutionsUnleashed() {
 
    const settings1 = {
        infinite: true,
        speed: 1500,
        arrows: false,
        slidesToShow: 6,
        autoplay: true,
        dots: true,
        autoplaySpeed: 2500,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 2,
                adaptiveHeight: true,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
      
              },
            },
        ],
    };
  return (
    <>
      <section className='solution-unleashed'>
      <div className='container'>
          <h3 className='ttl1'>Industries Explored, Solutions Unleashed</h3>
          <div className='solutionl-cont'>
            
             <Slider {...settings1} className='solutionl-list'>
             {HomePageData.IndustriesSolutions.map((response, index) => (
                 <div className='list-itm' key={index}>
                     <span>
                         <img src={response.slImg} className='img-fluid' alt={response.slHeading} width={51} height={50} />
                     </span>
                     <h4>{response.slHeading}</h4>
                 </div>
                 ))}              
             </Slider>          
         </div>
      </div>
      
      </section>
        
    </>
  )
}

export default SolutionsUnleashed
